import { render, staticRenderFns } from "./NavigationAddress.vue?vue&type=template&id=57bc2dde&scoped=true"
import script from "./NavigationAddress.vue?vue&type=script&lang=js"
export * from "./NavigationAddress.vue?vue&type=script&lang=js"
import style0 from "./NavigationAddress.vue?vue&type=style&index=0&id=57bc2dde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bc2dde",
  null
  
)

export default component.exports